import api from '@/api/api'

export default {
    async fetchBy(params) {
        try {
            let resp = await api.get(`/api/student-tags`, { params })

            return resp.data
        } catch (err) {
            throw 'Error fetching students tags'
        }
    },
}
